import React, { useEffect } from "react";

import { ClickAwayListener } from "@mui/base";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useModals } from "hooks";

import { IImagePreviewModal } from "../../../store/types/modals";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
  maxWidth: "90vw",
  maxHeight: "90vh"
};

export const ImagePreviewModal: React.FC<{ data: IImagePreviewModal | null }> = ({ data }): JSX.Element => {
  const { closeImageModal } = useModals();
  const { src } = data || {};

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !!src) {
        event.stopPropagation();
        event.preventDefault();
        closeImageModal();
      }
    };

    if (src) {
      document.addEventListener("keydown", handleEscape, true); // Use capture phase
    }

    return () => {
      document.removeEventListener("keydown", handleEscape, true);
    };
  }, [src, closeImageModal]);

  return (
    <Modal open={!!src} onClose={closeImageModal} disableEscapeKeyDown>
      <ClickAwayListener onClickAway={closeImageModal}>
        <Box component="img" sx={style} src={src} />
      </ClickAwayListener>
    </Modal>
  );
};
